import { render, staticRenderFns } from "./copybook.vue?vue&type=template&id=45f9b459&scoped=true&"
import script from "./copybook.vue?vue&type=script&lang=js&"
export * from "./copybook.vue?vue&type=script&lang=js&"
import style0 from "./copybook.vue?vue&type=style&index=0&id=45f9b459&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f9b459",
  null
  
)

export default component.exports